module.exports = __webpack_public_path__ + "img/map.872e7fe7.jpg";